export default function FormattingArea() {
  return (
    <>
      
    </>
  )
}